<template>
    <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
        <a-select  :allowClear="allowClear" :style="selectStyle" :dropdownMatchSelectWidth="false" :filterOption="filterOption" showSearch @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
            <a-icon slot="suffixIcon" type="caret-down" />
            <a-select-option v-for="(item,index) in filterCompanyInfos"  :disabled="item.showList == 0" :key="index"   :value="item.id"><div><span>{{item.name}}</span></div></a-select-option>
        </a-select>
        <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
    </div>
   <a-select v-else :allowClear="allowClear"  :dropdownMatchSelectWidth="false"  :filterOption="filterOption"  showSearch @change="changeValue" :optionLabelProp="optionLabelProp" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder=placeholder>
     <a-icon slot="suffixIcon" type="caret-down" />
     <a-select-option v-for="(item,index) in filterCompanyInfos" :disabled="deleteSelect? false : item.showList == 0" :key="index"   :value="item.id" :label="item.name"><div class="option_div"><span>{{item.name}}</span></div></a-select-option>
   </a-select>
</template>

<script>

  import Api from "@/api/sys/mainBody";
  import { mapState } from 'vuex'
  export default {
    name: 'ptMainBodySelect',
    props:{
	    expensed:{
		    type:Boolean,
		    default:false,
	    },
      deleteSelect:{
		    type:Boolean,
		    default:true,
	    },
      placeholder:{
        type:String,
        default:"请选择",
      },
      initValue:{
        default:true,
        type:Boolean,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [Object, Array] | String,
      },
      disabledUsers:{
        type:Array,
        default:()=>{return []}
      },
      filterText:{
        type:String,
        default:undefined,
      },
      companyId:{
        type:String,
      },
      loginDep:{
        type:String,
        default:false
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },
	    //是否设置默认值第一个
	    isFirst:{
		    type:Boolean,
		    default: false,
	    },
	    selectAll:{
		    type:Boolean,
		    default:false,
	    },
      optionLabelProp:{
        type:String,
        default:'label'
      },
    },
    data() {
      return {
        input:this.value,
	      companyInfos:[],
        open:false,
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
	    filterCompanyInfos(){
				if(!this.companyId){
					return this.companyInfos;
				}
				return this.companyInfos.filter(o=>o.companyId == this.companyId)
	    }
    },
    watch:{
      value (val) {
        this.input = val
        console.log("this.input",val)
      },
      input(val){
        this.$emit('input',val)
      },
      companyId(){
        this.initData(true)
      },
    },
    mounted(){
      this.initData(false)
    },
    methods:{
      dropdownVisibleChange(open){
        this.open = open
      },
      filterOption(input, option){
        return (
          option.componentOptions.children[0].children[0].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      initData(flag) {
        Api.listAll().then(res=>{
          if(res.code == 1) {
            this.companyInfos = res.data;
	          if(this.isFirst && (!this.value || this.value == '~')){
		          if(this.expensed){
			          let companyInfo = this.companyInfos.find(o=>o.id == this.userInfo.mainBodyId )
                if(companyInfo.showList != 0){
                  this.input = companyInfo.id;
                  this.$emit('input',this.input)
                  this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.input));
                }
		          }else{
			          this.input = this.userInfo.employeeDO.companyId
			          this.$emit('input',this.input)
			          this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.input));
		          }
	          }
	          if(this.selectAll && (!this.value || this.value == '~')){
		          let arr = [];
		          res.data.forEach(data=>{
			          arr.push(data.id)
		          })
		          this.input = arr;
		          this.$emit('input',this.input)
		          this.$emit('change',this.input,this.companyInfos.find(o=>o.id == this.input));
	          }
          }
        })
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('change',value,this.companyInfos.find(o=>o.id == value));
      }
    }
  }
</script>

<style scoped lang="less">
    .pt-select-div{
        position: relative;
        width: 100%;
        display: inline;
        /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
            margin-left: 0px;
        }
        .multiple-icon{
            position: absolute;
            color: rgba(0, 0, 0, 0.25);
            right: 11px;
            top: 10px;
            font-size: 12px;
        }
        .openClass{
            transform: rotate(180deg);
        }

    }

    .option_div{
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
</style>